import React from "react";
import Video from "../../FormFields/Video";

const MessageA6 = (props) => {
  return <Video {...props} />;
};

export default MessageA6;
